import * as httpClient from '../clients/httpClient'

const ERROR_MESSAGES = {
  BAD_REQUEST: 'Bad request.',
  SERVICE_ERROR: 'Service error.'
}

const putUserPreferences = async ({ adjustedCompanies, user }) => {
  const updateData = {
    shortName: user.shortName,
    fullName: user.fullName,
    companies: adjustedCompanies,
    products: user.products
  }

  const jsonResponse = await httpClient.getJsonResponse({
    path: `/users/${user._id}/settings`,
    body: updateData,
    method: 'PUT'
  })

  if (jsonResponse.statusCode >= 400 && jsonResponse.statusCode < 500) {
    console.error('BAD_REQUEST error in putUserPreferences', jsonResponse.body)
    throw new Error((jsonResponse.body && jsonResponse.body.error) || ERROR_MESSAGES.BAD_REQUEST)
  }

  if (jsonResponse.statusCode >= 500 && jsonResponse.statusCode < 600) {
    console.error('INTERNAL_SERVER error in putUserPreferences', jsonResponse.body)
    throw new Error((jsonResponse.body && jsonResponse.body.error) || ERROR_MESSAGES.SERVICE_ERROR)
  }

  return jsonResponse.body.data
}

export default { putUserPreferences }
